import { AuthLayout } from '@/features/auth/AuthLayout';
import { LoginForm } from '@/features/auth/LoginForm';
import { RedirectIfAuthed } from '@/features/auth/auth-guard';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});

function LoginPage() {
  const { t } = useTranslation();
  return (
    <RedirectIfAuthed>
      <AuthLayout eyebrow={t('auth.login.eyebrow', { defaultValue: 'Welcome back' })}>
        <LoginForm />
      </AuthLayout>
    </RedirectIfAuthed>
  );
}
